import { AxiosResponse } from 'axios';
import { useCallback } from 'react';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { ApiUrl } from '@/utils/constants';
import api from '@/utils/api';
import { LoginMessageResponse } from '@/types/api/mypage/loginMessage';
import { insertServiceIdInApiUrlSync } from '@/utils/common';
import useInsertServiceIdInApiUrl from '../useInsertServiceIdInApiUrl';

/** ログインメッセージ取得APIのURL */
const apiUrl = ApiUrl.Read.LOGIN_MESSAGE;

/**
 * ログインメッセージ取得APIの呼び出しフック。
 * ログイン直後に表示するバナー/ポップアップ情報を取得する。
 *
 * @returns execute - API実行関数
 */
const useGetLoginMessage = () => {
  const { insertServiceIdInApiUrl } = useInsertServiceIdInApiUrl();

  const execute = useCallback(
    /**
     * @param serviceId ログイン時など、非同期のためにuseInsertServiceIdInApiUrlでの変換時にserviceIdの取得が間に合わない場合に指定する
     */
    async (serviceId?: string): Promise<AxiosResponse<LoginMessageResponse>> => {
      // 通常は Recoil 上の現在サービスIDを使い、ログイン直後だけ引数優先でURLを組み立てる。
      let apiUrlWithServiceId = insertServiceIdInApiUrl(apiUrl);
      if (serviceId) {
        apiUrlWithServiceId = insertServiceIdInApiUrlSync(apiUrl, serviceId);
      }
      const headers = await getSigV4HeadersForGet(apiUrlWithServiceId);
      return api.get(apiUrlWithServiceId, headers);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return { execute };
};

export default useGetLoginMessage;
